export const STATES_NO_DATA = 'no_data';
export const STATES_NO_RECENT_DATA = 'no_recent_data';
export const STATES_WARNING = 'warning';
export const STATES_NO_CHANGE = 'no_change';

export const STATES_TREND_RISING = 'rising';
export const STATES_TREND_FALLING = 'falling';
export const STATES_TREND_STEADY = 'steady';
